import { dataActions } from "../slices/data";
import { popupActions } from "../slices/popups";
import { stateActions  } from "../slices/state";

const Actions = { ...dataActions, ...popupActions, ...stateActions  };

export default Actions;